import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/Button';
import { CreateGoal } from '../components/CreateGoal';
import { ProtectedLayout } from '../components/ProtectedLayout';
import { supabase } from '../lib/supabase';

export function CreatePlan() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    const loadUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        setUserId(user.id);
      } else {
        navigate('/');
      }
    };
    loadUser();
  }, [navigate]);

  const handleGoalCreated = () => {
    navigate('/dash-growth-loop');
  };

  const handleCreateLadder = (goalId: string) => {
    navigate(`/create-ladder/${goalId}`);
  };

  const handleCancel = () => {
    navigate('/dash-growth-loop');
  };

  if (!userId) {
    return (
      <ProtectedLayout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading...</p>
          </div>
        </div>
      </ProtectedLayout>
    );
  }

  return (
    <ProtectedLayout>
      <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 p-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-6">
            <Button
              variant="outline"
              onClick={handleCancel}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Dashboard
            </Button>
          </div>

          <CreateGoal
            userId={userId}
            onGoalCreated={handleGoalCreated}
            onCreateLadder={handleCreateLadder}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </ProtectedLayout>
  );
}
